export let isMobile = function() {
    let mobile_type = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return mobile_type ? true : false;
};


// WEBPACK FOOTER //
// ./src/assets/js/location.js